<template>
    <div class="ui segment center aligned">
        <div v-if="core_waybill.child_core_waybills && core_waybill.parent_core_waybills">
            <div class=""
                v-if="core_waybill.child_core_waybills.length != 0
                || core_waybill.parent_core_waybills.length != 0">

                <h4 v-if="core_waybill.parent_core_waybills.length" style="margin:0;">
                    {{ $t('ui.toolbox.core_waybill.parent_core_waybill') }}：

                    <span v-for="(parent_core_waybill, index) in core_waybill.parent_core_waybills" :data-tooltip="parent_core_waybill.original_number">
                        <span class="pointer" @click="show_core_wabill(parent_core_waybill.identity)">
                            {{ parent_core_waybill.number }}
                        </span>
                        <span v-if="parent_core_waybill.material"
                            style="font-size: smaller;">
                            [{{ parent_core_waybill.material.name }}]
                        </span>

                        <span v-if="index+1 != core_waybill.parent_core_waybills.length">
                            /
                        </span>

                    </span>
                </h4>
                <h4 v-if="core_waybill.child_core_waybills.length" style="margin-top:3px;">
                    {{ $t('ui.toolbox.core_waybill.child_core_waybill') }}：

                    <span v-for="(child_core_waybill, index) in core_waybill.child_core_waybills" :data-tooltip="child_core_waybill.original_number">
                        <span class="pointer" @click="show_core_wabill(child_core_waybill.identity)">
                            {{ child_core_waybill.number }}
                        </span>
                        <span v-if="child_core_waybill.material"
                            style="font-size: smaller;">
                            [{{ child_core_waybill.material.name }}]
                        </span>
                        <span v-if="index+1 != core_waybill.child_core_waybills.length">
                            /
                        </span>
                    </span>
                </h4>
            </div>
        </div>
        <div v-else>
            <h3>
                <!-- 無上下層運單 -->
                {{ $t('ui.toolbox.core_waybill.no_any_parent_and_child_waybill') }}
            </h3>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        scope: {
            default: 'provider',
            type: String
        },
        active_button_to_detail_route_name: {
            default: 'provider',
            type: String
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        show_core_wabill(identity = null) {
            try {
                if (!this.core_waybill.identity) {
                    throw "請輸入號碼"
                }
                this.$router.push({
                    name: this.active_button_to_detail_route_name,
                    params: {
                        identity: (identity) ? identity : this.core_waybill.identity
                    }
                })
            } catch (err) {
                this.$noty.error(err)
            }
        },
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
    .segment {
        margin-top: 0;
    }
</style>
